import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDateTime } from '~/common';

const Component = ({affiliates, selectedAffiliate, onContextMenu}) => {
    const getClassName = (affiliate) => {
        let className = 'context-menu';
        if (selectedAffiliate && selectedAffiliate.id === affiliate.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSUnresolvedVariable
    return (
        <TableContainer><Table>
            <TableHead><TableRow>
                <TableCell className="affiliate_name">Имя партнера</TableCell>
                <TableCell className="username">Имя пользователя</TableCell>
                <TableCell className="affiliate_id">ID партнера</TableCell>
                <TableCell className="last_login">Последний вход</TableCell>
            </TableRow></TableHead>
            <TableBody>
                {affiliates.map((affiliate) => (
                    <TableRow key={affiliate.id} className={getClassName(affiliate)}
                              onContextMenu={onContextMenu(affiliate)}
                    >
                        <TableCell className="affiliate_name">
                            <Link to={`/users/${affiliate.username}/`}>{affiliate.affiliate_name}</Link>
                        </TableCell>
                        <TableCell className="username">
                            <Link to={`/users/${affiliate.username}/`}>{affiliate.username}</Link>
                        </TableCell>
                        <TableCell className="affiliate_id">{affiliate.affiliate_id}</TableCell>
                        <TableCell className="last_login">
                            {(affiliate.last_login)
                                ? <>{formatDateTime(new Date(affiliate.last_login))}</>
                                : null
                            }
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table></TableContainer>
    );
};

Component.propTypes = {
    affiliates: PropTypes.array.isRequired,
    selectedAffiliate: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
